import React, { useContext } from 'react';

import FormData from './Form.context';
import Label from './Label.form';
import ErrorMsg from './ErrorMsg.form';

const Base = props => {
	const {
		required = false,
		name,
	} = props;

	const { register } = useContext(FormData);
	const reg = {};

	if (required)
		reg.required = 'Required';

	return (
		<div className='form-group-old'>
			<Label {...props} />

			<input
				name={name}
				ref={register(reg)}
			/>

			<ErrorMsg {...props} />
		</div>
	);
};

export default Base;
